import { Component, ComponentInterface, Element, h, Prop, VNode } from '@stencil/core';

import { uniAddClass, uniGetTargetElements, UniTemplate } from '@uiwebkit/common';
import { uniWatermark } from '@uni/license';

@Component({
  tag: 'uni-label-wrap',
  styleUrl: '../styles/label.css',
})
export class UniLabelWrapComponent implements ComponentInterface {

  @Element() el!: HTMLElement;

  @Prop({ reflect: true }) dataFor: string;

  @Prop({ reflect: true }) selector: string = 'label';

  render(): VNode {
    return UniTemplate(<slot />);
  }

  componentDidLoad(): void {
    uniWatermark('pro');

    uniGetTargetElements(this.el, false, this.selector)
      .forEach((child: HTMLElement) => {
        child.setAttribute('for', this.dataFor);
        uniAddClass(child, 'uni-label');
      });
  }
}
